
import React from 'react';
import { getRGB } from "../../../lib/color";
import { Link } from 'react-router-dom';
import { urlParamToObj } from "../../../lib/url-util";
import { Spinner } from "../../funcs/utils";

import {handle_token_dispatch} from "../../helper/token-dispatch";
import {AuthState} from "@ca/auth-identity/dist/auth";
import {DEVICE_WIDTH} from "../../../lib/constants";

const button_bg = "rgb(36, 36, 36)";
const inputBg = "rgb(42, 42, 42)";

const DISPLAY_LOGIN = 0;
const DISPLAY_NEW_ACCOUNT = 1;
const DISPLAY_NEW_ACCOUNT_PASSWORD = 5;
const DISPLAY_NEW_PASSWORD = 2;
const DISPLAY_FORGOT_PASSWORD = 3;
const DISPLAY_OTP = 4;

const ResetEmailState = {
  START: "START",
  LOADING: "LOADING",
  DONE: "DONE",
};

class LoginBox extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",
      first_name: "",
      last_name: "",
      email: "",
      new_pass_0: "",
      new_pass_1: "",
      phone_number: "",
      otp: "",
    };
  }

  componentDidMount() {
    this.window = window;
    window.requestAnimationFrame(this.onAnim);

    handle_token_dispatch(this, urlParamToObj(this.props.path));
  }

  onAnim = () => {}

  renderDarkButton = (text, cb, override = {}) => {
    const client = this.props.client;
    const text_color = getRGB(client.color.sign_on_button);

    const style = {
      fontFamily: "Poppins",
      fontWeight: "600",
      fontSize: "0.8rem",
      backgroundColor: button_bg,
      color: text_color,
      width: "100%",
      padding: "0.5rem 0",
      ...override,
    };
    return (
      <button
        style={style}
        onClick={cb}>
        { text }
      </button>
    );
  };

  renderLightButton = (text, cb, override = {}, button_id = null) => {
    const client = this.props.client;
    const bg_color = getRGB(client.color.sign_on_button);

    const style = {
      fontFamily: "Poppins",
      fontWeight: "600",
      fontSize: "1rem",
      backgroundColor: bg_color,
      color: "#000",
      width: "100%",
      padding: "0.5rem 0",
      border: "0",
      ...override,
    };
    return (
      <button
        id={button_id}
        style={style}
        onClick={cb}>
        { text }
      </button>
    );

  }

  createAccountNav = () => {
    this.props.pushPath("/new_account");
  };

  renderHeader = () => {
    const new_account_text = "Create New Account";
    const pass_text = "Set your new password";
    const forgot_text = "Forgot Password";

    const textStyle = {
      fontFamily: "Poppins",
      fontWeight: "600",
      color: "#FFF",
    };
    const topStyle = {
      ...textStyle,
      fontSize: "1.5rem",
    };
    const do_new_account = this.props.display === DISPLAY_NEW_ACCOUNT;
    const do_new_pass = this.props.display === DISPLAY_NEW_PASSWORD;
    const do_forgot = this.props.display === DISPLAY_FORGOT_PASSWORD;

    return (
      <div align={"center"}>
        { do_new_account && <div style={topStyle}>{new_account_text}</div> }
        { do_new_pass && <div style={topStyle}>{pass_text}</div>}
        { do_forgot && <div style={topStyle}>{forgot_text}</div>}
      </div>
    );
  };

  onReturnPressed = () => {
    if (this.props.display === DISPLAY_LOGIN) {
      this.signInCb();
    } else if (this.props.display === DISPLAY_NEW_ACCOUNT) {
      this.createAccountCb();
    } else if (this.props.display === DISPLAY_NEW_PASSWORD) {
      this.newPasswordCb();
    } else {
      console.log("Unknown display", this.props.display);
    }
  }

  renderInput = (param, hint, type="text", style_= {}) => {

    const onChange = ev => {
      this.setState({
        [param]: ev.target.value,
      });
    };


    const onKeyUp = ev => {
      const ReturnKey = 13;
      if (ev.nativeEvent.keyCode === ReturnKey) {
        this.onReturnPressed();
      }
    };

    const style = {
      width: "100%",
      fontFamily: "Poppins",
      padding: "0.5rem 1rem",
      backgroundColor: inputBg,
      marginBottom: "0.2rem",
      border: "0",
      color: "#FFF",
      ...style_,
    };
    const ref_prop = 'ref_' + param;

    return (
      <input
        type={type}
        placeholder={hint}
        style={style}
        id={param}
        value={this.state[param]}
        ref={this[ref_prop]}
        onChange={onChange}
        onKeyUp={onKeyUp}/>
    );
  };

  signInCb = () => {
    this.props.onLogin(this.state.username, this.state.password);
  };

  renderMessage = (msg, style_override = {}) => {
    const style = {
      paddingTop: "1rem",
      fontFamily: "Poppins",
      fontWeight: "600",
      fontSize: "1rem",
      color: "#F00",
      ...style_override,
    }
    return (
      <div style={style}>{msg}</div>
    )
  };

  createAccountCb = () => {
    this.props.onNewAccount(
      this.state.first_name, this.state.last_name, this.state.email,
      this.state.phone_number, this.state.password);
  }

  getContainerDivStyle = () => {
    const is_small = this.is_small_layout();
    const style = {
      backgroundColor: getRGB(this.props.client.color.sign_on_background),
      padding: "1rem 2rem",
      maxWidth: "350px",
    };
    if (is_small) {
      style.alignSelf = "center";
    } else {
      style.display = "inline-block";
      style.marginLeft = "8rem";
    }
    return style;
  };

  getInnerDivStyle = () => {
    return {
      backgroundColor: getRGB(this.props.client.color.sign_on_background),
    };
  }

  is_small_layout = () => {
    return this.props.app.width <= DEVICE_WIDTH.medium;
  }

  doHyperverge = () => {
    return this.props.app.wlf.apps
      && this.props.app.wlf.apps.hyperverge;
  }

  renderLogin = () => {

    const container_style = {
      ...this.getContainerDivStyle(),
      ...this.props.style,
    };

    const params = urlParamToObj(this.props.path);
    const acct_exists = !!params.acct_exists;
    const create_acct_on_login = !!params.create_acct_on_login;
    const acct_confirmed = params.acct_exists === "confirmed";
    const acct_exists_text = acct_confirmed
      ? "Seems like you’re an existing user! Sign in to create a new account linked to your email."
      : "Your password was sent to your email";
    const msg_style = {
      color: "#FFF",
      margin: '0 20px',
    }
    const light_button = this.props.doingLogin
      ? (<i className="fa fa-circle-o-notch fa-spin login-spinner"></i>)
      : "SIGN IN";

    const error = this.props.error;
    const do_error = !!error;
    const link_style = {
      color: "#FFF",
    }
    return (
      <div id="login-box" style={container_style}>
        <div style={this.getInnerDivStyle()} align={"center"}>
          { this.renderHeader() }
          <div style={{height: "1rem" }}/>
          { this.renderInput("username", "User Name") }
          { this.renderInput("password", "Password", "password") }
          <div style={{height: "0.5rem"}}/>
          { this.renderLightButton(light_button, this.signInCb, {}, "sign-in")}
          { do_error && this.renderMessage(error) }
          { acct_exists && this.renderMessage(acct_exists_text, msg_style )}
          <div style={{height: "1rem"}}/>
          <Link style={link_style} to={"/forgot_password"}>FORGOT PASSWORD?</Link>
          <div style={{height: "1rem"}}/>
          { !create_acct_on_login && this.renderLightButton(
            "CREATE AN ACCOUNT", this.createAccountNav, {}, 'create-account') }
        </div>
      </div>
    );
  };

  renderNewAccount = (do_set_passwd) => {
    const container_style = {
      ...this.getContainerDivStyle(),
      ...this.props.style,
    };

    const button_text = this.props.doingCreateAccount
      ? (<i className="fa fa-circle-o-notch fa-spin login-spinner"></i>)
      : "CREATE ACCOUNT";

    const do_hyper = this.doHyperverge();
    const inst_0 = do_hyper
      ? "Enter your phone number, email," : "Enter your name, email,";
    const inst_1 = "and hit CREATE ACCOUNT";

    const error = this.props.error;
    const do_error = !!error;
    const span_style = {
      fontFamily: "Poppins",
      fontWeight: "600",
      color: "#FFF",
    };
    return (
      <div id="create-account-box" style={container_style}>
        <div style={this.getInnerDivStyle()} align={"center"}>
          { this.renderHeader() }
          <div style={{ marginTop: "1rem" }}>
            <span style={span_style}>{inst_0}</span>
          </div>
          <div>
            <span style={span_style}>{inst_1}</span>
          </div>
          <div style={{height: "1rem" }}/>
          { !do_hyper && this.renderInput("first_name", "First Name") }
          { !do_hyper && this.renderInput("last_name", "Last Name") }
          { do_hyper && this.renderInput("phone_number", "Phone number") }
          { do_set_passwd && this.renderInput("password", "Password", "password") }
          <div style={{height: "0.5rem" }}/>
          { this.renderInput("email", "Email") }
          <div style={{height: "0.5rem" }}/>
          { this.renderLightButton(
            button_text, this.createAccountCb, {}, "create-account") }
          { do_error && this.renderMessage(error) }
        </div>
      </div>
    );
  };

  newPasswordCb = () => {
    this.props.onSetPassword(
      this.state.new_pass_0, this.state.new_pass_1);
  }

  renderNewPassword = () => {
    const container_style = {
      ...this.getContainerDivStyle(),
      ...this.props.style,
    };

    const button_text = this.props.settingPassword
      ? (<i className="fa fa-circle-o-notch fa-spin login-spinner"></i>)
      : "SET NEW PASSWORD";
    const error = this.props.error;
    const do_error = !!error;

    return (
      <div id="new-password" style={container_style}>
        <div style={this.getInnerDivStyle()} align={"center"}>
          { this.renderHeader() }
          <div style={{height: "2rem" }}/>
          { this.renderInput("new_pass_0", "New Password", "password") }
          { this.renderInput("new_pass_1", "Retype password", "password") }
          <div style={{height: "0.5rem" }}/>
          { this.renderLightButton(button_text, this.newPasswordCb) }
          { do_error && this.renderMessage(error) }
        </div>
      </div>
    )
  };

  renderOTP = () => {
    const container_style = {
      ...this.getContainerDivStyle(),
      ...this.props.style,
      width: "350px",
    };

    const header_text = {
      fontSize: "1.5rem",
      color: "#FFF",
    }
    const instructions_style = {
      fontSize: "1rem",
      color: "#FFF",
    }
    const input_style = {
      textAlign: "center",
      fontSize: "1.5rem",
      letterSpacing: "0.5rem",
    }
    const resend = () => {
      this.props.resendOTP();
    }
    const verify = () => {
      this.props.twoFAotp(this.state.otp);
    }
    const is_sending = this.props.user.isFetching;
    const otp_text = is_sending
      ? (<Spinner/>) : "Verify Now";
    const error = this.props.error;
    const do_error = !!error;
    const can_resend = this.props.user.login_state === AuthState.OTP;
    const resend_text = this.props.user.otp_sending
      ? (<Spinner/>) : "Resend Code";

    return (
      <div id="otp" style={container_style}>
        <div style={this.getInnerDivStyle()} align={"center"}>
          <div style={header_text}>Enter One Time Passcode</div>
          <div style={{height: "2rem" }}/>
          { this.renderInput("otp", "", "text", input_style) }
          <div style={{height: "1rem"}}/>
          { this.renderLightButton(otp_text, verify) }
          { do_error && this.renderMessage(error) }
          <div style={{height: "2rem" }}/>
          <div style={instructions_style}>
            A passcode was sent to your email.
          </div>
          <div style={instructions_style}>
            This code is good for 10 minutes.
          </div>
          { can_resend && <div style={{height: "2rem" }}/> }
          { can_resend && this.renderLightButton(resend_text, resend) }
        </div>
      </div>
    )
  }

  forgotPassword = () => {
    const container_style = {
      ...this.getContainerDivStyle(),
      ...this.props.style,
    };
    const span_style = {
      fontFamily: "Poppins",
      fontWeight: "600",
      color: "#FFF",
    };
    const text_0 = "Enter your email below.";
    const state = this.props.reset_email_state;
    const show_button = state === ResetEmailState.START
      || state === ResetEmailState.LOADING;
    const button_text = state === ResetEmailState.LOADING
      ? Spinner()
      : "SEND RESET EMAIL";
    const email_sent_text = "Reset email has been sent.";
    const is_done = state === ResetEmailState.DONE;

    const onClick = () => {
      this.props.onSendResetEmail(this.state.email);
    };

    return (
      <div id="reset-password" style={container_style}>
        <div style={this.getInnerDivStyle()} align={"center"}>
          { this.renderHeader() }
          <div style={{height: "2rem" }}/>
          <div>
            <span style={span_style}>{text_0}</span>
          </div>
          <div style={{height: "2rem" }}/>
          { this.renderInput("email", "Email") }
          <div style={{height: "0.5rem" }}/>
          { show_button && this.renderLightButton(button_text, onClick) }
          <div>
            { is_done && <span style={span_style}>{email_sent_text}</span> }
          </div>
          <div style={{height: "0.5rem" }}/>
        </div>
      </div>
    )
  }

  render = () => {
    if (this.props.display === DISPLAY_LOGIN) {
      return this.renderLogin();
    } else if (this.props.display === DISPLAY_NEW_ACCOUNT) {
      return this.renderNewAccount();
    } else if (this.props.display === DISPLAY_NEW_ACCOUNT_PASSWORD) {
      return this.renderNewAccount(true);
    } else if (this.props.display === DISPLAY_NEW_PASSWORD) {
      return this.renderNewPassword();
    } else if (this.props.display === DISPLAY_FORGOT_PASSWORD) {
      return this.forgotPassword();
    } else if (this.props.display === DISPLAY_OTP) {
      return this.renderOTP();
    }
    return null;
  }
}

export { LoginBox, DISPLAY_NEW_ACCOUNT, DISPLAY_LOGIN, DISPLAY_OTP, DISPLAY_NEW_ACCOUNT_PASSWORD,
  DISPLAY_NEW_PASSWORD, DISPLAY_FORGOT_PASSWORD, ResetEmailState };
